(() => {
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const money=(cents,currency='GBP')=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency}).format((Number(cents)||0)/100)}catch{return `£${((Number(cents)||0)/100).toFixed(2)}`}};
  const toast=(message)=>{let el=qs('[data-toast]');if(!el){el=document.createElement('div');el.className='toast';el.dataset.toast='';document.body.appendChild(el)}el.textContent=message;el.classList.add('is-visible');clearTimeout(el._t);el._t=setTimeout(()=>el.classList.remove('is-visible'),2400)};

  const menu=qs('[data-mobile-menu]');
  qsa('[data-menu-open]').forEach(b=>b.addEventListener('click',()=>{menu?.classList.add('is-open');document.body.classList.add('menu-open')}));
  qsa('[data-menu-close]').forEach(b=>b.addEventListener('click',()=>{menu?.classList.remove('is-open');document.body.classList.remove('menu-open')}));

  const overlay=qs('[data-drawer-overlay]'), drawer=qs('[data-cart-drawer]');
  const openDrawer=()=>{drawer?.classList.add('is-open');overlay?.classList.add('is-open');document.body.classList.add('drawer-open')};
  const closeDrawer=()=>{drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');document.body.classList.remove('drawer-open')};
  qsa('[data-cart-open]').forEach(b=>b.addEventListener('click',async()=>{await refreshCart();openDrawer()}));
  qsa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  overlay?.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeDrawer();menu?.classList.remove('is-open');document.body.classList.remove('menu-open')}});

  const escapeHtml=s=>String(s??'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  async function refreshCart(){
    try{
      const r=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}}); const cart=await r.json();
      qsa('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0});
      const title=qs('[data-cart-title]'); if(title) title.textContent=`Your Bag (${cart.item_count})`;
      const body=qs('[data-cart-items]'), footer=qs('[data-cart-footer]'); if(!body)return cart;
      if(!cart.items.length){body.innerHTML='<div class="cart-empty"><p class="muted">Your bag is empty.</p><a class="button button--primary" href="/collections/all">Shop the range</a></div>'; if(footer)footer.hidden=true;return cart}
      if(footer)footer.hidden=false;
      const threshold=Number(drawer?.dataset.freeShipping||0)*100, remaining=Math.max(0,threshold-cart.total_price);
      let html=remaining>0?`<p class="drawer-shipping">You're ${money(remaining,cart.currency)} away from complimentary shipping.</p>`:'';
      html+=cart.items.map(item=>`<div class="drawer-item">
        <a class="drawer-item__image" href="${item.url}">${item.image?`<img src="${item.image}" alt="${escapeHtml(item.product_title)}">`:''}</a>
        <div><div class="drawer-item__top"><div><a class="drawer-item__title" href="${item.url}">${escapeHtml(item.product_title)}</a>${item.variant_title&&item.variant_title!=='Default Title'?`<div class="drawer-item__variant">${escapeHtml(item.variant_title)}</div>`:''}</div><button class="remove-button" type="button" aria-label="Remove item" data-cart-remove data-key="${escapeHtml(item.key)}">×</button></div>
        <div class="drawer-item__bottom"><div class="qty-control"><button type="button" data-qty-minus data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}">−</button><span>${item.quantity}</span><button type="button" data-qty-plus data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}">+</button></div><span>${money(item.final_line_price,cart.currency)}</span></div></div></div>`).join('');
      body.innerHTML=html;
      const subtotal=qs('[data-cart-subtotal]'); if(subtotal)subtotal.textContent=money(cart.total_price,cart.currency);
      bindCartControls(); return cart;
    }catch(e){console.error(e)}
  }
  async function changeCart(id,quantity){
    await fetch(`${window.Shopify?.routes?.root||'/'}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id,quantity})}); await refreshCart();
  }
  function bindCartControls(){
    qsa('[data-cart-remove]').forEach(b=>b.addEventListener('click',()=>changeCart(b.dataset.key,0)));
    qsa('[data-qty-minus]').forEach(b=>b.addEventListener('click',()=>changeCart(b.dataset.key,Math.max(0,Number(b.dataset.qty)-1))));
    qsa('[data-qty-plus]').forEach(b=>b.addEventListener('click',()=>changeCart(b.dataset.key,Number(b.dataset.qty)+1)));
  }
  bindCartControls();

  qsa('form[data-ajax-add], form.ajax-add-form').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault(); const submit=qs('[type="submit"]',form); if(submit)submit.disabled=true;
    try{const r=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}); if(!r.ok){const er=await r.json().catch(()=>({}));throw new Error(er.description||'Could not add item')};const item=await r.json();await refreshCart();openDrawer();toast(`${item.product_title||'Item'} added to your bag`)}catch(err){toast(err.message||'Could not add item')}finally{if(submit)submit.disabled=false}
  }));

  /* Product gallery + variant controls */
document.addEventListener('click', function(event) {

  const thumb = event.target.closest('[data-product-thumb]');

  if (thumb) {
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery?.querySelector('[data-main-product-image]');

    gallery?.querySelectorAll('[data-product-thumb]').forEach(item => {
      item.classList.remove('is-active');
    });

    thumb.classList.add('is-active');

    if (main && thumb.dataset.image) {
      main.removeAttribute('srcset');
      main.src = thumb.dataset.image;
      main.alt = thumb.dataset.alt || '';
    }
  }


  const variantButton = event.target.closest('[data-variant-button]');

  if (variantButton) {
    if (variantButton.disabled) return;

    const wrap = variantButton.closest('[data-product-form-wrap]');
    if (!wrap) return;

    const select = wrap.querySelector('select[name="id"]');
    const price = wrap.querySelector('[data-product-price]');
    const compare = wrap.querySelector('[data-product-compare]');
    const addButton = wrap.querySelector('[data-product-submit]');
    const mainImage = document.querySelector('[data-main-product-image]');

    wrap.querySelectorAll('[data-variant-button]').forEach(button => {
      button.classList.remove('is-active');
    });

    variantButton.classList.add('is-active');

    if (select) {
      select.value = variantButton.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (price && variantButton.dataset.price) {
      price.textContent = variantButton.dataset.price;
    }

    if (compare) {
      compare.textContent = variantButton.dataset.compare || '';
      compare.hidden = !variantButton.dataset.compare;
    }

    if (addButton) {
      const available = variantButton.dataset.available === 'true';

      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to bag' : 'Sold out';
    }

    if (mainImage && variantButton.dataset.image) {
      mainImage.removeAttribute('srcset');
      mainImage.src = variantButton.dataset.image;
    }
  }

});
  qsa('[data-sort-select]').forEach(sel=>sel.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('sort_by',sel.value);location.href=url.toString()}));

  if('IntersectionObserver'in window){const ob=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');ob.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -8% 0px'});qsa('.reveal').forEach(el=>ob.observe(el))}else{qsa('.reveal').forEach(el=>el.classList.add('is-visible'))}
})();
